import { Component, computed, input } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { isDefined } from "@recursyve/nice-ts-utils";
import { DirectusTranslationPipe } from "../../../../common/pipes/directus-translation.pipe";
import {
    sanitizeDirectusArray,
    sanitizeDirectusObject,
    sanitizeDirectusRelationObject
} from "../../../../common/utils/sanitize-directus-object";
import { ItemsSupplierShowcaseBlock } from "../../../api/packbo/models/items-supplier-showcase-block";
import { ItemsSuppliers } from "../../../api/packbo/models/items-suppliers";
import { PackageBadgeComponent } from "../../../components/package-badge/package-badge.component";
import { SupplierCarouselComponent } from "../../directory/supplier/components/supplier-carousel/supplier-carousel.component";

@Component({
    selector: "packbo-supplier-showcase-block",
    templateUrl: "./supplier-showcase-block.template.html",
    imports: [DirectusTranslationPipe, TranslocoPipe, SupplierCarouselComponent, PackageBadgeComponent]
})
export class SupplierShowcaseBlockComponent {
    public readonly supplierShowcaseBlock = input.required<ItemsSupplierShowcaseBlock>();

    public readonly suppliers = computed(() => {
        const suppliersRefs = this.supplierShowcaseBlock()?.suppliers_refs;
        if (!suppliersRefs) {
            return [];
        }

        const activeSuppliers = sanitizeDirectusArray(suppliersRefs)
            .map((item) => sanitizeDirectusObject(item.suppliers_id))
            .filter((supplier): supplier is ItemsSuppliers => {
                if (
                    !isDefined(supplier) ||
                    !isDefined(supplier.logo) ||
                    !isDefined(supplier.is_active) ||
                    !supplier.is_active
                ) {
                    return false;
                }

                const packageRef = sanitizeDirectusRelationObject(supplier, "package_ref");
                if (!isDefined(packageRef) || typeof packageRef === "number") {
                    return false;
                }

                return packageRef.is_showcase_membership === true;
            });

        return activeSuppliers;
    });

    public readonly package = computed(() => sanitizeDirectusObject(this.suppliers()[0]?.package_ref));
}
